<template>
    <!-- Generato da claude — Ricevute redesign Proposta A -->
    <div>
        <div class="card" v-if="socio.pagamenti && socio.pagamenti.length > 0">
            <div class="card-header card-header-background">
                <span class="dk-header-title">🧾 Le mie ricevute</span>
                <span class="dk-header-badge">{{socio.pagamenti.length}}</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-list-item"
                    v-for="pagamento in socio.pagamenti"
                    :key="pagamento.ID_PAGAMENTO"
                    @click="esportaPagamento(pagamento)">
                    <div class="dk-list-icon">🧾</div>
                    <div class="dk-list-info">
                        <div class="dk-list-title">Ricevuta {{pagamento.NUMERO_RICEVUTA_FORMATTATO}}</div>
                        <div class="dk-list-sub">{{filters.formatDate(pagamento.DATA_PAGAMENTO)}}</div>
                    </div>
                    <div class="dk-list-action d-flex align-items-center gap-2">
                        <strong style="font-size:1rem; color:var(--dk-navy)">
                            € {{filters.formattaImporto(pagamento.IMPORTO)}}
                        </strong>
                        <i class="fas fa-download fa-sm" style="color:var(--dk-muted)"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-else>
            <div class="card-header card-header-background">
                <span class="dk-header-title">🧾 Le mie ricevute</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-empty-state">
                    <span class="dk-empty-state-icon">🧾</span>
                    Nessuna ricevuta disponibile
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Ricevute',
    data: function() {
        return {
            filters: global.filters,
            socio: {},
        }
    },
    methods: {
        esportaPagamento(pagamento) {
            // Generato da claude — niente SESSION_TOKEN in query string: forzerebbe session_id() lato server
            // sovrascrivendo il cookie di sessione valido con un token stale, causando pagina bianca.
            // FROM=deskalo invece va tenuto: senza, ASSOSPRINT_determinaIdEnte() non riconosce il
            // contesto deskalo (l'host della API è gestionale.assosprint.it, non "deskalo"), l'idEnte
            // risultante (2) fa prendere al codice il ramo staff che legge $utenteLoggato (assente per
            // una sessione socio), producendo una query SQL con FK_ID_SOCIETA vuoto.
            window.open(utils.BASE_API + 'deskalo/report?PAGAMENTI=' + pagamento.ID_PAGAMENTO + '&FROM=deskalo');
        },
    },
    created() {
        utils.ajax('/deskalo/socio', {}, (response) => {
            this.socio = response.data;
        });
    },
}
</script>
